import dynamic from "next/dynamic";

import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export const ValuesContainer = styled("div")(
  ({ theme }) => css`
    display: grid;
    margin-top: 0.5rem;
    margin: 0 auto;

    ${theme.breakpoints.up("mobile")} {
      padding: 0.5rem 16px;
      gap: 1.5rem;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 0.5rem 64px;
      width: ${theme.breakpoints.values.tablet}px;
      grid-template-columns: repeat(2, 1fr);
      gap: 2.5rem;
    }

    ${theme.breakpoints.up("desktop")} {
      padding: 2.5 110px;
      width: ${theme.breakpoints.values.desktop}px;
      grid-template-columns: repeat(3, 1fr);
    }

    ${theme.breakpoints.up("desktopXl")} {
      width: ${theme.breakpoints.values.desktopXl}px;
    }
  `,
);

export const LottieContainer = styled("div")(
  ({ theme }) => css`
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${getColor(x => x.tokens.stroke["soft-200"], theme)};
    background-color: ${getColor(x => x.tokens.bg["white-0"], theme)};
    border-radius: 10px;
    margin-bottom: 24px;
  `,
);

export const LottieStyled = styled(Lottie)(
  ({ theme }) => css`
    width: 36px;
    height: 36px;

    ${theme.palette.mode === "dark" &&
    css`
      filter: invert();
    `}
  `,
);

export const ValueHeader = styled("div")(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.paragraph_xxlarge_semibold)}
    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
    margin-bottom: 0.5rem;
  `,
);

export const ValueText = styled("div")(
  ({ theme }) => css`
    ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};
  `,
);
